// extracted by mini-css-extract-plugin
export default {"root":"Quarter_root__sfjE0"};